import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/API";
import { downloadPdfData } from "../../common-components/commonFunctions";

export interface Detailinterface {
  _id:string;
  PARENT_ISBN: string;
  TESTIMPRINTFROMHNA: any;
  EDITOR:any;
  EAN:any,
  SEASON: any;
  ISBN: any;
  AUTHOR_1:any;
  AMAZON_SUBTITLE:any;
  FULL_TITLE: any;
  RELEASE_DATE: any;
  PUBMONTH: any;
  PUB_DATE: any;
  AGE_RANGE: any;
  US_PRICE: any;
  BISAC_STATUS: any;
  UK_PRICE: any;
  CANADIAN_PRICE: any;
  ANNOUNCED_1ST_PRINTING__BEST: any;
  SERIES: any;
  FORMAT: any;
  // TRIM SIZE: any;
  PAGES: any;
  TERRITORY: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  CARTON_QTY: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  TRIMWIDTH: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  TRIMLENGTH: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  RIGHTS: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  GRADE_LEVEL: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  DISCOUNT: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  AUDIENCE: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  PROD_MGR: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  ORIGIN: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  MANAGING_EDITOR: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  PUBLICITY_UPDATE: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  PARTICIPANTS: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  COMPETITIVE_TITLES: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  LICENSED: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  LICENSOR: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  SECOND_LICENSOR: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  WAREHOUSE_DATE: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  ASIN: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  DESIGNER: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  PROMOTIONAL_PERIOD: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  PAPER_CUT_OFF: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  LDC: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  PUBLICIST: any; //Added newly  beacuse it is required for bussiness 07/01/2026
  INSERTS_ILLUS: any;
  BISAC1_DESC: any;
  BISAC2_DESC: any;
  BISAC3_DESC: any;
  DESCRIPTION: any;
  AUTHOR_BIO: any;
  PUBLICITY: any;
  CATEGORY1: any;
  CATEGORY2: any;
  CATEGORY3: any;
  MARKETING_BULLETS__FACT_SHEET: any;
  IMAGE_URL: any;
  imageBase64String:string;
}

interface DetailState {
  data: Detailinterface;
  status: string;
  statusCode: number;
  error: string | null;
  selectedDetail: string;
    loading:boolean;
  isLoading: boolean;
   authorized: string | boolean;
   fetchLoaded:boolean
}
const initialState: DetailState = {
  data: {
    PARENT_ISBN: "",
    BISAC_STATUS:"",
    _id:"",
    imageBase64String:"",
    EAN:"",
    AUTHOR_1:"",
    AMAZON_SUBTITLE: "",
    TESTIMPRINTFROMHNA: null,
    SEASON: null,
    ISBN: null,
    FULL_TITLE: null,
    RELEASE_DATE: null,
    PUBMONTH: null,
    PUB_DATE: null,
    AGE_RANGE: null,
    US_PRICE: null,
    UK_PRICE: null,
    CANADIAN_PRICE: null,
    ANNOUNCED_1ST_PRINTING__BEST: null,
    EDITOR: null,
    SERIES: null,
    FORMAT: null,
    PAGES: null,
    TERRITORY: null, // Newly added field for business requirement 07/01/2026
    CARTON_QTY: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    TRIMWIDTH: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    TRIMLENGTH: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    RIGHTS: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    GRADE_LEVEL: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    DISCOUNT: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    AUDIENCE: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    PROD_MGR: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    ORIGIN: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    MANAGING_EDITOR: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    PUBLICITY_UPDATE: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    PARTICIPANTS: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    COMPETITIVE_TITLES: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    LICENSED: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    LICENSOR: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    SECOND_LICENSOR: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    WAREHOUSE_DATE: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    ASIN: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    DESIGNER: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    PROMOTIONAL_PERIOD: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    PAPER_CUT_OFF: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    LDC: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    PUBLICIST: null, //Added newly  beacuse it is required for bussiness 07/01/2026
    INSERTS_ILLUS: null,
    BISAC1_DESC: null,
    BISAC2_DESC: null,
    BISAC3_DESC: null,
    DESCRIPTION: null,
    AUTHOR_BIO: null,
    PUBLICITY: null,
    CATEGORY1: null,
    CATEGORY2: null,
    CATEGORY3: null,
    MARKETING_BULLETS__FACT_SHEET: null,
    IMAGE_URL: null,
  },
    loading:false,
  status: "",
  error: null,
   authorized: "",
  statusCode: 0,
  isLoading: false,
  selectedDetail: "",
  fetchLoaded:false
};
export let currentController: AbortController | null = null; 


export const FetchDetailsRecord = createAsyncThunk(
  "FetchDetailsRecord",
  async (data: any, { rejectWithValue }) => {
    try {
        if (currentController) {
        currentController.abort();
      }
      currentController = new AbortController();
      const { signal } = currentController;
      // Use id as fallback if isbn is null/undefined to prevent /undefined in URL
      const isbnParam = data?.isbn || data?.id || '';
      const url = `${API.FETCHDETAILSRECORD}/${data?.id}/${isbnParam}`;
      const response = await axios.get(url, { signal });
      return response;
    } catch (err: any) {
      if (axios.isCancel(err) || err.name === "CanceledError") {
        console.warn("FetchDetailsRecord request aborted");
        return rejectWithValue("Request cancelled");
      }
      return rejectWithValue(err.response);
    }
    finally {
      currentController = null;
    }
  }
);


export const checkAuthorization = createAsyncThunk(
  "checkAuthorization",
  async (data: { column: string; isbn: string; value: any }, { rejectWithValue }) => {
    try {
      const url = `${API.checkAuthorization}`;
      const payload = {
        column: data.column,
        isbn: data.isbn,
        value: data.value,
      };

      const response = await axios.post(url, payload);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || err.message);
    }
    finally {
      currentController = null;
    }
  }
);
export const PostpdfData=createAsyncThunk("Postpdf",async(data:any,{rejectWithValue})=>{
  try{
    const response=await axios.get( `${API.DOWNLOADPDF}/${data.id}`,{responseType:"blob"})
    return response;
  }catch(err:any){
    return rejectWithValue(err.response)
  }
})



// export const handleDownloadPdf = async () => {
//   try {
//     const response = await axios.post('/api/pdf', {
//       responseType: 'arraybuffer', 
//     });
//     downloadPdfData(response.data);
//   } catch (error) {
//     console.error('Error downloading PDF:', error);
//   }
// };

const bookSlice = createSlice({
  name: "book",
  initialState,
  reducers: {
    setDetails: (state, action) => {
      state.selectedDetail = action.payload;
    },

    setAuthorized: (state, action) => {
      state.authorized = action.payload;
    },
    emptyDetailsPageRecord: (state) => {
      state.data = initialState.data;
      state.error = initialState.error;
      state.isLoading = initialState.isLoading;
      state.loading = initialState.loading;
      state.selectedDetail = initialState.selectedDetail;
      state.status = initialState.status;
      state.statusCode = initialState.statusCode;
    }, 
    resetAuthorization: (state) => {
      state.authorized = initialState.authorized;
    },
    setfetchLoaded:(state,action)=>{
      state.fetchLoaded=action.payload
    }
  },
  extraReducers(builder) {
    builder
      .addCase(FetchDetailsRecord.pending, (state) => {
        state.isLoading = true;
         state.loading = true;
        state.status = "Loading";
      })
      .addCase(FetchDetailsRecord.fulfilled, (state, action) => {
       
        state.isLoading = false;
        state.loading = false;
        state.status = "success";
        state.data = action.payload.data.data;
        state.data.imageBase64String = action.payload.data.imageBase64;

      })
      .addCase(FetchDetailsRecord.rejected, (state) => {
        state.isLoading = false;  
        state.loading = false;  
        state.status = "Failed";
          state.loading = false;

        state.error = "Error";
      })
      .addCase(PostpdfData.pending, (state) => {
        state.isLoading = true;
        state.status = "Loading";
      })
      .addCase(PostpdfData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = "success";
        
        state.data = action.payload.data;
        console.log( action.payload.data,"pdffff")
      })
      .addCase(PostpdfData.rejected, (state) => {
        state.isLoading = false;
        state.status = "Failed";
        state.error = "Error";
      })




       .addCase(checkAuthorization.pending, (state) => {
        state.isLoading = true;
        state.loading = true;
        state.status = "Loading";
      })
      .addCase(checkAuthorization.fulfilled, (state, action) => {
        state.status = "success";
        state.authorized = `${action.payload.authorized}`;
        state.isLoading = false;
        state.loading = false;
      })
      .addCase(checkAuthorization.rejected, (state) => {
        state.isLoading = false;
        state.loading = false;
        state.status = "Failed";
        state.authorized = "false";
      })
  },
});

export const {setfetchLoaded,setDetails,setAuthorized,resetAuthorization, emptyDetailsPageRecord} = bookSlice.actions;

export default bookSlice.reducer;
